/**
 * Primary screen script. Imports all of the various features so that they can
 * be bundled into a final file during the build process.
 *
 * @author Marcin Misiewicz <marcin.misiewicz.pl@gmail.com>
 * @link https://github.com/marcin-misiewicz-pl/awiw-theme
 */

import GLightbox from 'glightbox';
import domReady from '@wordpress/dom-ready';
import Accordion from './accordion';

domReady(() => {
	document.querySelectorAll('.wp-block-gallery.is-style-lightbox').forEach((gallery, index) => {
		gallery.setAttribute('data-glightbox-gallery-index', index);
		GLightbox({ selector: `.wp-block-gallery.is-style-lightbox[data-glightbox-gallery-index='${index}'] a` });
	});
	const accordion = new Accordion(true, '.accordion', '.is-style-accordion-header', '.is-style-accordion-content');
});
